export default __webpack_public_path__ + "static/media/CelebrationDinner Schedule.95dcf149.jpg";